export default "__VITE_ASSET__C6$t81S0__"